export const ESC_KEY = 27
export const TITLE_COLOR = '#210d87'
export const BANNER_TITLE = 'Open Movie Database Browser'
export const FETCH_TIMEOUT = 10000
export const OMDB_API_URL_AUTHORITY = 'https://www.omdbapi.com'
export const OMDB_API_KEY = 'fbfcb8c7'
